import React from 'react';
import { PaginatedSelectContext } from './context';

interface PaginatedSelectProviderProps {
  children: React.ReactNode;
  value: import('./context').PaginatedSelectContextValue;
}

export function PaginatedSelectProvider({ children, value }: PaginatedSelectProviderProps) {
  return (
    <PaginatedSelectContext.Provider value={value}>{children}</PaginatedSelectContext.Provider>
  );
}
